import { SETUP_CUSTOM_DOMAIN, SETUP_CUSTOMER_PORTAL } from "./types";

export const customerPortalDataLoad = ({smid, response}) => {
    return {
      type: SETUP_CUSTOMER_PORTAL,
      payload: {[smid]: response}
    };
};

export const setCustomDomainData = (payload) => {
  return {
    type: SETUP_CUSTOM_DOMAIN,
    payload: payload,
  }
}